import { Flex } from 'components/base/layout-components';
import Text from 'components/base/Text';
import _ from 'lodash';
import useSettingsService from 'components/hooks/useSettingsService';
import { pmFiltersBuilder } from 'components/FilterMenus/pm.filters';
import { PM_PROVIDERS } from 'common/constants/constants';
import FilterMenusV2 from 'components/FilterMenus/FilterMenusV2';
import { FILTER_TYPES } from 'common/constants/filters';

export const SetFiltersSection = ({
  title,
  description,
  buttonMinWidth,
  selectedItems,
  setSelectedItems
}) => {
  const filterMenusFilters = _.omit(selectedItems, [
    'issue_types',
    'issue_states',
    'state_transitions'
  ]);

  const onDeleteFilter = (filterType, id) => {
    const updatedFilters = _.omitBy(
      {
        ...selectedItems,
        [filterType]: selectedItems?.[filterType].filter(item => item.id !== id)
      },
      _.isEmpty
    );
    setSelectedItems(updatedFilters);
  };

  const { getSettingOrDefinitionValue } = useSettingsService();

  const menuItemsV2 = pmFiltersBuilder(
    {
      [PM_PROVIDERS.JIRA]: [
        FILTER_TYPES.BOARD,
        FILTER_TYPES.EPIC,
        FILTER_TYPES.LABEL,
        FILTER_TYPES.FIELD,
        FILTER_TYPES.ORGANIZATION_TEAMS
      ],
      [PM_PROVIDERS.AZURE_BOARDS]: [
        FILTER_TYPES.EPIC,
        FILTER_TYPES.LABEL,
        FILTER_TYPES.FIELD,
        FILTER_TYPES.ORGANIZATION_TEAMS
      ]
    },
    getSettingOrDefinitionValue
  );

  return (
    <>
      <Text size='medium' mb='0.5rem'>
        {title}
      </Text>
      <Flex items='center'>
        <Text color='shuttleGray' size='medium' mr='0.4rem'>
          {description}
        </Text>
      </Flex>
      <Flex mt='small' mb='medium'>
        <FilterMenusV2
          documentIdPrefix={title}
          key={title}
          menuItems={menuItemsV2}
          selectedFilters={filterMenusFilters}
          setSelectedFilters={newFilters => {
            setSelectedItems(prev => ({ ...prev, ...newFilters }));
          }}
          onDeleteFilter={onDeleteFilter}
          buttonMinWidth={buttonMinWidth}
          customFieldById={true}
          withMargin={false}
        />
      </Flex>
    </>
  );
};
